import { Injectable } from '@angular/core';
import { first } from 'rxjs';

import { PcTabletErrorDialogComponent } from '@UIparts/common/error-dialog/pc-tablet-ver/error-dialog.component';
import { ErrorDialogData } from '@VineyardLib/data/error-dialog-data';
import { ErrorDialogWrapperService } from '@VineyardLib/services/error-dialog-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class PcTabletErrorDialogService implements ErrorDialogWrapperService {
  private isErrorDialogOpen = false;
  public errorDialog: PcTabletErrorDialogComponent | null = null;

  openErrorDialog(data: ErrorDialogData): void {
    if (this.isErrorDialogOpen || this.errorDialog == null) {
      return;
    }
    this.isErrorDialogOpen = true;
    this.errorDialog.openDialog(data);
    this.errorDialog.dialogClosed?.pipe(first()).subscribe(() => {
      this.isErrorDialogOpen = false;
    });
  }
}
